export default __webpack_public_path__ + "static/media/image.3c1a2ad8.png";